// imports
import WaveSurfer from 'wavesurfer.js';

// set some color variables
let a = '#FFA8DE'; // pink
let b = '#fed412'; // yellow
let cursorColor = '#bd3812';

/**
 *
 * @param {Element} container
 */

export async function render(container, filename) {
  // select waveform's container element
  let containerId = container.id;
  let containerElement = document.querySelector(
    '#' + containerId + '-waveform'
  );

  // and the play pause buttons
  let play = container.querySelector('#' + containerId + '-play');
  let pause = container.querySelector('#' + containerId + '-pause');

  let playSvg = play.querySelector('span');
  let pauseSvg = pause.querySelector('span');

  // and set their colors
  playSvg.style.color = a;
  pauseSvg.style.color = a;

  // wavesurfer config
  let wavesurfer = WaveSurfer.create({
    container: containerElement,
    height: 29,
    barWidth: 3,
    barRadius: 30,
    barHeight: 0.9,
    barGap: null,
    cursorWidth: 2,
    pixelRatio: 1,
    normalize: true,
    waveColor: a,
    progressColor: b,
    responsive: true,
    cursorColor: cursorColor,
    backend: 'MediaElementWebAudio',
  });

  // load file
  wavesurfer.load(filename);

  // set volume
  wavesurfer.setVolume(0.8);

  // init
  wavesurfer.on('ready', function () {
    let duration = wavesurfer.getDuration();
    let currentTime = wavesurfer.getCurrentTime();

    const durationContainer = document.getElementById(
      containerId + '-duration'
    );
    const currentTimeContainer = document.getElementById(
      containerId + '-current'
    );

    // append timestamp
    function addTimestamp(val) {
      // convert seconds to minutes
      let minutes = Math.floor(val / 60);
      let seconds = Math.round(val - minutes * 60);

      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      return minutes + ':' + seconds;
    }
    durationContainer.append(addTimestamp(duration));
    currentTimeContainer.append(addTimestamp(currentTime));

    // play button
    play.addEventListener('click', function () {
      wavesurfer.play();
      playAnimation();
      play.classList.add('hidden');
      pause.classList.remove('hidden');
    });

    // pause button
    pause.addEventListener('click', function () {
      wavesurfer.pause();
      pauseAnimation();
      pause.classList.add('hidden');
      play.classList.remove('hidden');
    });

    // move the cursor
    function playAnimation() {
      wavesurfer.play();
    }

    function pauseAnimation() {
      wavesurfer.pause();
    }

    // reset the player when sound is finished playing
    wavesurfer.on('finish', function () {
      pause.classList.add('hidden');
      play.classList.remove('hidden');

      wavesurfer.seekTo(0);

      playSvg.style.fill = a;
      wavesurfer.setWaveColor(a);
    });

    // advance the timestamp as audio plays
    let count = 0;
    wavesurfer.on('audioprocess', function () {
      count += 1;
      currentTime = wavesurfer.getCurrentTime();
      currentTimeContainer.innerHTML = addTimestamp(currentTime);
    });

    // adjust timestamp if you seek/skip on the timeline
    wavesurfer.on('seek', function () {
      currentTime = wavesurfer.getCurrentTime();
      currentTimeContainer.innerHTML = addTimestamp(currentTime);
    });
  });
}
